<template>
    <div class="news">
        <div class="news_container">
            <div class="news_top">
                <div class="title">{{ this.news.title }}</div>
                <div class="time">{{ this.news.publishAt ? this.news.publishAt : this.news.createdAt  }}</div>
            </div>
            <div class="news_middle">
                <div class="content-container" v-html="sanitizedRichText">
                </div>
                <div class="content-bottom">
                    <p class="source" >来源：{{ this.news.source }}</p>
                    <div class="source-url"><a :href="this.news.sourceUrl" target="_blank">原文链接</a></div>
                </div>
                <div class="news_bottom">
                <div class="bottom_container">
                    <div class="prev">
                        <span>上一篇：</span>
                        <span style="display: contents; flex-wrap: nowrap;" :title="this.news.prevTitle" v-if="this.news.prevId" class="title" @click="goNews('prev')">《{{ this.news.prevTitle }}》</span>
                        <span v-else >已经是第一篇</span>
                    </div>
                    <div class="next">
                        <span>下一篇：</span>
                        <span style="display: contents; flex-wrap: nowrap;" :title="this.news.nextTitle" v-if="this.news.nextId" class="title" @click="goNews('next')">《{{ this.news.nextTitle }}》</span>
                        <span v-else>已经是最后一篇</span>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getNewsDetail } from '../../util/index'
import DOMPurify from 'dompurify';
export default {
    data() {
        return {
            newsItem: null,
            news: {
                title:'',
                content: '',
                imageUrl: '',
                createdAt:'',
                publishAt: '',
                source: '',
            },
            graph: [],
            preNews: {
                title: ''
            },
            nextNews: {
                title: ''
            }
        }
    },
    computed: {
        sanitizedRichText() {
            return DOMPurify.sanitize(this.news.content);
        }
    },
    methods:{
        getNewNews(id){
            let token = window.localStorage.getItem('userToken')
            getNewsDetail(id, token).then(res => {
                if(res.code === 200) {
                    let data = res.data
                    this.news = data
                    // let first = this.news.content.indexOf("。")
                    // this.news.firstGraph = this.news.content.substring(0,first+1)
                    // this.news.lastGraph = this.news.content.substring(first+1)
                    // this.graph = this.news.lastGraph.match(/[^。]+。[\s|　]*/g)
                }
            })
        },
        goNews(which){
            let id
            if(which === 'prev'){
                id = this.news.prevId
            }else{
                id = this.news.nextId
            }
            // 新开一个页面
            window.open(`/news?id=${id}`)
        }
    },
    mounted() {
        let id = this.$route.query.id
        console.log(this);
        // let newsItem = this.$route.query.newsItem
        // if(newsItem){
        //     this.news = JSON.parse(newsItem)
        //     let first = this.news.content.indexOf("。")
        //     this.news.firstGraph = this.news.content.substring(0,first+1)
        //     this.news.lastGraph = this.news.content.substring(first+1)
        //     this.graph = this.news.lastGraph.match(/[^。]+。[\s|　]*/g)
        // }
        this.getNewNews(id)
    }
}
</script>

<style scoped lang="less">
.news{
    background-color: #000;
    min-height: 100vh;
}
.news_container{
    width: 80%;
    margin: 0 auto;
    .news_top{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 5.75rem 0 2.56rem;
        border-bottom: 1px solid #818182;
        width: 80%;
        margin: 0 auto;
        .title{
            color: #fff;
            font-family: AliMedium;
            font-size: 2.18rem;
        }
        .time{
            padding-top: 1.13rem;
            color: #999999;
            font-size: 0.85rem
        }
    }
    .news_middle{
        width: 70%;
        margin: 0 auto;
        padding: 4.56rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        white-space: pre-line;
        .content-container{
            width: 100%;
            font-size: 0.97rem;
            color: #CCCCCC;
            line-height: 2.18rem;
            text-align: left;
            white-space: pre-line;
        }
        .content-bottom{
            display: flex;
            justify-content: space-between;
            width: 100%;
            .source{
                // width: 100%;
                font-size: 0.97rem;
                color: #CCCCCC;
                line-height: 2.18rem;
                text-align: left;
                white-space: pre-line;
                margin-top: 20px;
                padding-left: 5px;
                border-left: 4px red solid;
            }
            .source-url{
                font-size: 0.97rem;
                color: #CCCCCC;
                line-height: 2.18rem;
                text-align: left;
                white-space: pre-line;
            }
        }
    }
    .news_bottom{
        border-top: 1px solid #818182;
        padding: 4rem 0;
        width: 100%;
        margin-top: 30px;
        .bottom_container{
            width: 100%;
            margin: 0 auto;
            line-height: 2.5;
            color: #fff;
            display: flex;
            // flex-direction: column;
            // align-items: center;
            justify-content: space-between;
            .title{
                cursor: pointer;
            }
        }
    }
}
</style>
<style scoped>
::v-deep .news_middle .content-container .ql-align-center{
    text-align: center;
}
</style>